/**
 * 收费处路由
 */
const basePath = 'operating-theater'
var operatingTheaterRoutes = [{
  path: `${basePath}/theater-patient-list`,
  name: `${basePath}/theater-patient-list`,
  meta: {
    title: '手术病人列表',
    requiresAuth: true,
    nav: {
      title: '工作站',
      path: '/default/workplace',
      children: null
    }
  },
  component: resolve => require(['../views/page/operating-theater/theater-patient-list.vue'], resolve)
}]

var areaPatientMetaNav = {
  title: '工作站',
  path: '/default/workplace',
  children: {
    title: '手术病人',
    path: `/default/${basePath}/theater-patient-list`
  }
}
var areaPatientBaseName = 'theater-patient-manage'
operatingTheaterRoutes.push({
  path: `${basePath}/theater-patient-manage/:type/:inpatient_record_id/:id`, // create_user inpatient_record_id patient_id
  name: `${basePath}/theater-patient-manage`,
  redirect: function (route) {
    let params = route.params
    return `${basePath}/theater-patient-manage/${params.inpatient_record_id}/${params.id}` + '/fee'
  },
  meta: {
    title: '手术病人',
    requiresAuth: true,
    nav: areaPatientMetaNav
  },
  component: resolve => require(['../views/page/operating-theater/theater-patient-manage.vue'], resolve),
  children: [{
    path: 'fee',
    name: `${areaPatientBaseName}-fee`,
    meta: {
      title: '手术病人-手术费用',
      requiresAuth: true,
      nav: areaPatientMetaNav
    },
    component: resolve => require(['../views/page/operating-theater/components/fee.vue'], resolve)
  }, {
    path: 'fee-summary',
    name: `${areaPatientBaseName}-fee-summary`,
    meta: {
      title: '手术病人-费用汇总',
      requiresAuth: true,
      nav: areaPatientMetaNav
    },
    component: resolve => require(['../views/page/operating-theater/components/fee-summary.vue'], resolve)
  }, {
    path: 'fee-cancel',
    name: `${areaPatientBaseName}-fee-cancel`,
    meta: {
      title: '手术病人-退费管理',
      requiresAuth: true,
      nav: areaPatientMetaNav
    },
    component: resolve => require(['../views/page/operating-theater/components/fee-cancel.vue'], resolve)
  }, {
    path: 'fee-type-in',
    name: `${areaPatientBaseName}-fee-type-in`,
    meta: {
      title: '手术病人-费用录入',
      requiresAuth: true,
      nav: areaPatientMetaNav
    },
    component: resolve => require(['../views/page/operating-theater/components/fee-type-in.vue'], resolve)
  }]
})

export default operatingTheaterRoutes
